// RimoCompta's hook-up of the suite context menu (RimoCore/shared/ctx): look = the app's dropdowns (the menu's
// defaults), labels in the UI language (read at every right-click, the language can switch), the compta toast, the
// Tauri clipboard on the desktop, and no word-pair translation inside the menu (its labels are already translated).
import { readText, writeText } from '@tauri-apps/plugin-clipboard-manager';
import { configureContextMenu, webClipboard } from '@rimocore/shared/ctx/ContextMenu';
import { tr2 } from '../../i18n/lang';
import { isDesktop } from '../../platform';
import { toast } from './toast';

configureContextMenu({
  toast,
  noTranslate: true,
  labels: () => ({
    cut: tr2('Ausschneiden', 'Couper'), copy: tr2('Kopieren', 'Copier'), paste: tr2('Einfügen', 'Coller'), selectAll: tr2('Alles auswählen', 'Tout sélectionner'),
    copied: (what, shown) => tr2(`${what} kopiert: ${shown}`, `${what} copié : ${shown}`),
    copyFailed: tr2('Kopieren nicht möglich.', 'Copie impossible.'),
    pasteWith: (keys) => tr2(`Einfügen mit ${keys}`, `Coller avec ${keys}`),
  }),
  clipboard: {
    async write(text) {
      try { if (isDesktop()) { await writeText(text); return true; } } catch { /* fall through to the web API */ }
      return webClipboard.write(text);
    },
    async read() {
      try { if (isDesktop()) return await readText(); } catch { /* fall through */ }
      return webClipboard.read();
    },
  },
});
